import React, { Component } from "react";
import { connect } from "react-redux";
import {Grid, Hidden, Button, Input, FormHelperText, FormControl, Box} from "@material-ui/core";
import {Helmet} from 'react-helmet';
import style from "./style";
import { parentContainer } from "../../config/theme";
import Banner from "../../components/Banner";
import Header from "../../components/Header";
import StackCards from "../../components/StackCards";
import CustomCenterDivider from "../../components/CustomCenterDivder/CustomCenterDivider";
import CustomCenterHeader from "../../components/CustomCenterHeader";
import Footer from "../../components/Footer";
import SignUpDrawer from "../../components/SignUpDrawer";
import {emailRegex} from "../../config/constants";
import { NotificationManager } from "react-notifications";

import ReactGA from 'react-ga';
import { GA_CODE } from '../../config/constants';

class Landing extends Component {
  state = {
    openSignUpDrawer: false,
    email:'',
    emailErrMsg: "",
    emailErr: false,
    showVideo: true
  };

  constructor(props) {
    super(props);
    ReactGA.initialize(GA_CODE);
  }

  toggleSignUpDrawer = () => {
    this.props.history.push({
      pathname: '/sign-up',
      search: `?type=diner`,
      state: { type: "diner" }
    });
  };

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  componentDidUpdate(newProps) {
    if (!!this.props.userId) {
      this.props.history.push("/home/dashboard");
    }
  }

  onSubscribe(){
    const { email } = this.state;
    if (email.trim().length <= 0) {
      this.setState({
        errors: true,
        emailErr: true,
        emailErrMsg: "Email is required"
      });
      console.log("emailErrMsg", email);
    } else if (!emailRegex.test(email.trim())) {
      this.setState({
        errors: true,
        emailErr: true,
        emailErrMsg: "Invalid Email"
      });
      console.log("emailErrMsg", email);
    } else {
      fetch('https://cuisinecrafters.net/apis/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({email, type: 'diner'})
      })
        .then(response => response.json())
        .then(result => {
          this.setState({ errors: false, emailErr: false, emailErrMsg: "Successfully Subscribed", email: "", disabled: false, });
          setTimeout(() => this.setState({ emailErrMsg: "" }), 2500);
        })
        .catch(error => {
          this.setState({ errors: false, emailErr: false, emailErrMsg: "", email: "", disabled: false, });
        });
      NotificationManager.info('Subscribed successfully', 'Subscribe', 3000);
      this.setState({ email: '' });
    }


  }

  handleInputChange = e => {
    const { name, value } = e.target;
        this.setState({ email: value });
  };

  render() {
    return (
      <div style={parentContainer}>
        <Helmet>
          <title>Experience Great Food at Home With Our In-Home Cooking Service</title>
          <meta name="description" content="Stop wasting time going to the grocery store and cooking your meals. Our in-home cooking service brings a chef right to your home. Learn more about our services." />
          <link rel="canonical" href="https://cuisinecrafters.net/diner" />
          <meta name="robots" content="index, follow, max-snippet:-2, max-image-preview: large, max-video-preview:-1" />
        </Helmet>
        <Grid container>
          <Grid item xs={12}>
            <Header history={this.props.history} />
            <Banner type="diner" history={this.props.history} />
          </Grid>

          <div className="page-video-container page-video-container-diner">
            <Hidden smDown>
              <h3>Find out how Cuisine Crafters can help you get more out of life</h3>
            </Hidden>
            <Hidden mdUp>
              <h3>Find out how<br />Cuisine Crafters<br />can help you get<br />more out of life</h3>
            </Hidden>
            <div className="video-container">
              <video
                controls
                preload
                id="chef-vid"
                poster="/images/diner-thumbnail-video.png"
              >
                <source type="video/mp4" src="https://cc-videos-staging.s3.us-east-2.amazonaws.com/user-signup.mp4"/>
              </video>
            </div>
          </div>

          <div className="chef-page-container" style={{ backgroundColor: '#ff8000' }}>
            <div className="chef-page-content chef-page-content-invert">
              <h3>Fine Dining, Right From the Comfort of Your Own Home</h3>
              <p>
                At Cuisine Crafters, we match cooks, chefs, and home cooks (also known as Crafters TM) with people who want to have a personal chef or a fantastic dining experience. Whether you're hosting a dinner party or want someone to cook your meals regularly, we have a solution for you.
              </p>
              <p>
                The chefs at Cuisine Crafters have been thoroughly vetted and food safety certified. You can choose from a wide range of meals and cuisines, depending upon what you're craving that day.
              </p>
              <p>
                Get started with Cuisine Crafters and take your dining experience to the next level.
              </p>
            </div>
          </div>

          <div className="chef-page-container" style={{ backgroundColor: '#fff' }}>
            <div className="chef-page-content">
              <h3>Explore the Benefits of Cuisine Crafters</h3>
              <p>
                Cooking a meal at the end of a long day or for a dinner party can mean sacrificing energy and time. An in-home cooking service, like Cuisine Crafters, ensures you can relax while enjoying a well-prepared meal.
              </p>
            </div>
          </div>

          <div className="chef-page-container" style={{ backgroundColor: '#ff8000' }}>
            <div className="chef-page-content chef-page-content-invert">
              <h3>Spend Less Time Grocery Shopping</h3>
              <p>
                Preparing and cooking a meal isn't the only thing that takes a lot of your time. Grocery shopping and locating hard-to-find ingredients can take up a considerable chunk of your free time. On top of that, you have to sit down and plan out your meals and ingredients.
              </p>
              <p>
                A personal chef from Cuisine Crafters will handle that for you. They'll plan a selection of meals based on your preference. Your chef will take over your meals' planning, shopping, preparing, and cooking.
              </p>
            </div>
          </div>

          <div className="chef-page-container" style={{ backgroundColor: '#fff', marginBottom: 60 }}>
            <div className="chef-page-content">
              <h3>Eat Out Less</h3>
              <p>
                While grabbing take-out can be nice here and there, it's not the best for everyday dining. Fast food and restaurant dining can include lots of hidden calories and unhealthy ingredients. You have little or no control over what you eat and how it's prepared.
              </p>
              <p>
                With a personal chef, you'll enjoy fresh ingredients prepared according to your preferences. If you're embarking on a healthy eating regimen, your personal chef will consider that when planning and cooking your meals.
              </p>
            </div>
          </div>

          <CustomCenterDivider />

          <div className="head-col">
            <Hidden mdUp>
              <CustomCenterHeader
                text="Great cuisines, crafted at home"
                mobile={true}
              />
            </Hidden>
            <Hidden smDown>
              <CustomCenterHeader
                text="Great cuisines, crafted at home"
                computer={true}
              />
            </Hidden>
            <div className="diner-sub-heading">
              <p>Good food is never a problem again. See how our platform helps you have a great dining experience.</p>
            </div>
          </div>
        </Grid>

        <Grid className="landing-container" container direction="row" spacing={32}>
          <Box className="landing-box landing-box-diner-one" onClick={() => this.props.history.push('/sign-up')}>
            <StackCards
              image="/images/time.png"
              txtHeader="Sign-Up"
              txtSub={
                <div>
                  Sign-up for an account.<br /><br /><br />
                </div>
              }
              title="Sign up Cuisine crafter"
              alt="Cuisine Crafters - Sign Up"
              step="1"
            />
          </Box>
          <Box className="landing-box">
            <StackCards
              image="/images/home.png"
              txtHeader="Meet Your Chef"
              txtSub={
                <div>
                  Your Crafter TM will come to your home at your chosen time.<br /><br />
                </div>
              }
              title="Meet Your Chef at your Home"
              alt="Cuisine Crafters - Book Chef"
              step="2"
            />
          </Box>
          <Box className="landing-box">
            <StackCards
              image="/images/cuisines.png"
              txtHeader="Enjoy Delicious Meals"
              txtSub={
                <div>
                  Step outside of your comfort zone and enjoy meals from worldwide cultures.
                </div>
              }
              title="Enjoy Food at home"
              alt="Cuisine Crafters - Enjoy Food"
              step="3"
            />
          </Box>
        </Grid>

          <Grid item xs={12} style={{ margin: "100px 0" }} />

        <div className="chef-page-container" style={{ backgroundColor: '#ff8000' }}>
          <div className="chef-page-content chef-page-content-invert">
            <h3>Why Choose Cuisine Crafters</h3>
            <p>
              At Cuisine Crafters, our goal is to save you time and money. At the end of a long day, the last thing you want to do is drive and wait at a restaurant or be tied to your stove. Let one of our chefs make and serve you a delicious meal while you relax in the comfort of your home or get chores done.
            </p>
            <p>
              Our chefs are also available for special events. Hosting a birthday party, anniversary, or another occasion can be stressful. Spend more time with your guests, enjoying the party, instead of worrying about the food.
            </p>
          </div>
        </div>

        <div className="chef-page-container" style={{ backgroundColor: '#fff' }}>
          <div className="chef-page-content">
            <h3>Get Started With Cuisine Crafters Today</h3>
            <p>
              Start exploring new cuisines and dishes made by professional chefs. Explore the world through food without ever leaving your house. Sign-up for a Cuisine Crafters account today.
            </p>
          </div>
        </div>

          <Hidden mdUp>
            <div style={{textAlign: 'center'}}>
              <CustomCenterHeader
                className="text-center"
                text="Start exploring cuisines today!"
                mobile={true}
              />
            </div>
          </Hidden>
          <Hidden smDown>
            <CustomCenterHeader
              text="Start exploring cuisines today!"
              computer={true}
            />
          </Hidden>
          <Grid item xs={12} style={{ margin: "20px 0" }} />
          <Grid item xs={12} style={style.centerGrid}>
            <Button onClick={this.toggleSignUpDrawer} style={style.getStarted}>
              Get Started
            </Button>
          </Grid>

          <Grid item xs={12} style={{ margin: "100px 0" }} />

          <Grid item xs={12} style={style.specialDiv}>
            <Hidden mdUp>
              <CustomCenterHeader text="Dining experience 101" mobile={true} />
            </Hidden>

            <Hidden smDown>
              <CustomCenterHeader
                text="Dining experience 101"
                computer={true}
              />
            </Hidden>

            <Grid item xs={12}>
              See how you can explore the world through handcrafted
              <br />
              cuisines at the convenience of your home.
            </Grid>

            <Grid item xs={12} style={{ margin: "30px 0" }} />

            {/*<Grid container>
              <Grid item xs={12} style={style.centerGrid}>
                <Hidden smDown>
                  <FormControl>
                  <Input
                    placeholder="Enter email"
                    style={style.subscribeField}
                    disableUnderline={true}
                    error={this.state.emailErr}
                    value={this.state.email}
                    onChange={this.handleInputChange}
                  />
                    <FormHelperText
                        style={
                          this.state.emailErr
                              ? { ...style.setFont, ...style.error }
                              : { ...style.setFont, ...style.msg }
                        }
                    >
                      {this.state.emailErrMsg}
                    </FormHelperText>
                  </FormControl>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.onSubscribe.bind(this)}
                    style={style.subscribeBtn}
                  >
                    Subscribe
                  </Button>
                </Hidden>
                <Hidden mdUp>
                  <form
                      action="#!"
                      method="post"
                      style={{ width: "100%" }}
                  >
                  <Grid container direction="row" spacing={0}>
                    <Grid item xs={1} sm={4} />
                    <Grid item xs={6} sm={3}>
                      <FormControl style={{display: 'flex', justifyContent: 'flex-end'}}>
                      <Input
                        error={this.state.emailErr}
                        placeholder="Enter email"
                        value={this.state.email}
                        onChange={this.handleInputChange}
                        style={style.subscribeField}
                        disableUnderline={true}
                      />
                      <FormHelperText
                          style={
                            this.state.emailErr
                                ? { ...style.setFont, ...style.error }
                                : { ...style.setFont, ...style.msg }
                          }
                      >
                        {this.state.emailErrMsg}
                      </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={4} sm={3}>
                      <Grid container style={{justifyContent: 'flex-start'}}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.onSubscribe.bind(this)}
                          style={style.subscribeBtn}
                        >
                          Subscribe
                        </Button>
                      </Grid>
                    </Grid>
                    <Grid item sm={2} />
                  </Grid>
                  </form>
                </Hidden>
              </Grid>
            </Grid>*/}

            <Grid container>
              <Grid item xs={12} style={style.centerGrid}>
                <Hidden smDown>
                  <FormControl>
                    <Input
                      placeholder="Enter Email"
                      style={style.subscribeField}
                      disableUnderline={true}
                      error={this.state.emailErr}
                      value={this.state.email}
                      onChange={this.handleInputChange}
                    />
                    <FormHelperText
                      style={
                        this.state.emailErr
                          ? { ...style.setFont, ...style.error }
                          : { ...style.setFont, ...style.msg }
                      }
                    >
                      {this.state.emailErrMsg}
                    </FormHelperText>
                  </FormControl>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.onSubscribe.bind(this)}
                    style={style.subscribeBtn}
                  >
                    Subscribe
                  </Button>
                </Hidden>
                <Hidden smUp>
                  <form
                    action="#!"
                    method="post"
                    style={{ width: "100%" }}
                  >
                    <Grid container direction="row" spacing={0}>
                      <Grid item xs={1} />
                      <Grid item xs={6}>
                        <FormControl>
                          <Input
                            error={this.state.emailErr}
                            placeholder="Enter Email"
                            value={this.state.email}
                            onChange={this.handleInputChange}
                            style={style.subscribeField}
                            disableUnderline={true}
                          />
                          <FormHelperText
                            style={
                              this.state.emailErr
                                ? { ...style.setFont, ...style.error }
                                : { ...style.setFont, ...style.msg }
                            }
                          >
                            {this.state.emailErrMsg}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={4}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.onSubscribe.bind(this)}
                          style={style.subscribeBtn}
                        >
                          Subscribe
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </Hidden>
              </Grid>
            </Grid>
          </Grid>

          <Footer />

          <SignUpDrawer
            cancelChannelSignUp={this.toggleSignUpDrawer}
            openSignUpDrawer={this.state.openSignUpDrawer}
            toggleSignUpDrawer={this.toggleSignUpDrawer}
          />
        {/*{this.state.showVideo && <div className="video-container">
          <span className="close-button" onClick={() => this.setState({ showVideo: false })}>x</span>
          <video
            controls
            muted
            autoplay={"autoplay"}
            preload
          >
            <source type="video/mp4" src="https://cc-videos-staging.s3.us-east-2.amazonaws.com/user-signup.mp4" />
          </video>
          <button className="video-signup-button" onClick={() => this.props.history.push('/sign-up')}>
            Change my life now!
          </button>
        </div>}
        {!this.state.showVideo && <div className="video-container-hidden" onClick={() => this.setState({ showVideo: true })}>
          Continue Video
        </div>}*/}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId
  };
};

const LandingPage = connect(mapStateToProps)(Landing);

export default LandingPage;
